<template>
    <van-cell-group class="UPassword">
      <van-field
        class="inputBar"
        label-class="textBar"
        v-model="onePassword"
        type="password"
        label="新密码"
        placeholder="请输入新密码"
        required
      />
      <van-field
        class="inputBar"
        label-class="textBar"
        v-model="twoPassword"
        type="password"
        label="确认密码"
        placeholder="请输入确认密码"
        required
        :error-message="PwdValidateText"
        :blur="PwdValidate"
      />
      <van-col span="24" type="flex" justify="space-between" class="barBtn">
        <van-button round type="danger" size="large" class="saveBth" @click.prevent="UpdatePwd">保存</van-button>
      </van-col>
    </van-cell-group>
</template>

<script>
  import { Toast } from 'vant'
  import { reqUpdatePwd } from '../../api'
	export default {
    name:"updatepassword",
    data () {
      return {
        userId:'',
        onePassword:'',
        twoPassword:'',
        PwdValidateText:'',
      }
    },
    created(){
      this.userId = this.$cookies.get('userInfo').userId
    },
    methods:{
      PwdValidate () {
        if(this.onePassword!=''&&this.twoPassword!=''){
          if(this.onePassword==this.twoPassword){
            this.PwdValidateText = '';
            return true
          }else{
            this.PwdValidateText = '两次密码不一致！';
            return false
          }
        }else{
          this.PwdValidateText = '请输入密码!';
          return false
        }
      },
      UpdatePwd () {
        let _that = this
        let isPwd = this.PwdValidate()
        if(isPwd){
          let pwdData={
            userId:this.userId,
            password:this.onePassword
          }
          reqUpdatePwd(pwdData).then(res => {
            if(res.success){
              this.$cookies.remove('userInfo');
              this.$cookies.set('userInfo',res.data);
              Toast.success({message:'保存成功！',className:'apiLoading',onClose:function(){
                  _that.$router.push({
                    path:'/settings',
                    name:'settings'
                  })
              }});
            }else {
              Toast.fail({message:'服务暂停！',className:'apiLoading'});
            }
          })
        }
      },
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "../../common/stylus/mixins.styl"
  .UPassword
    background #f9f9f9
    .inputBar
      font-size 26px
      border-bottom 1px solid #f9f9f9
    .van-field__label
      width 120px
      height 98px
      line-height 98px
      padding-left 10px
    .van-field__body
      line-height 98px
    .van-cell--required::before
      line-height 98px
      font-size: 28px!important
    .van-field__error-message
      font-size: 22px
      padding-bottom 10px
    .barBtn
      padding 20% 40px 0px
      .saveBth
        color #ffffff
        font-size 32px
        background #ff6d02
        height 88px
        margin-top 100px
        line-height 88px
</style>



// WEBPACK FOOTER //
// src/pages/Settings/UpdatePassword.vue